<template>
    <div>
        <ToolBar :menu="'Tiếp nhận dữ liệu QLNT'" :content="'Báo cáo tình hình nộp dữ liệu'"
            :subContent="'Báo cáo tình hình nộp dữ liệu cấp Sở '">
        </ToolBar>
        <CustomTable :column-form="2" :hideBtnTable="true" :title="'Báo cáo tình hình nộp dữ liệu cấp sở'">
            <template v-slot:title-actions>
                <CustomButton label="Tìm kiếm" @click="handleSearch" />
            </template>
            <template v-slot:header>
                <tr>
                    <th>STT</th>

                    <th>Đơn vị quản lý</th>
                    <th class="text-right">Tổng số trường học</th>
                    <th class="text-right">Tổng số cán bộ</th>
                    <th class="text-right">Tổng số lớp đơn</th>
                    <th class="text-right">Tổng số lớp ghép</th>
                    <th class="text-right">Tổng số học sinh</th>
                    <th class="text-right">Tổng số KQ HK I</th>
                    <th class="text-right">Tổng số KQ HK II</th>
                    <th class="text-right">Tổng số KQ cả năm</th>
                    <th class="text-right">Tổng số HS tốt nghiệp</th>
                </tr>
            </template>
            <template v-slot:body>
                <tr v-for="(item, index) in tableData" :key="index">
                    <td>
                        {{ (currentPage - 1) * limit + index + 1 }}
                    </td>

                    <td class="text-left">
                        {{ item.tenDonVi }}
                    </td>
                    <td class="text-right">
                        {{ item.totalTruongHoc }}
                    </td>
                    <td class="text-right">
                        {{ item.totalCanbo }}
                    </td>
                    <td class="text-right">
                        {{ item.totalLopDon }}
                    </td>

                    <td class="text-right">
                        {{ item.totalLopGhep }}
                    </td>

                    <td class="text-right">
                        {{ item.totalHocsinh }}
                    </td>
                    <td class="text-right">
                        {{ item.totalKQHocKi1 }}
                    </td>

                    <td class="text-right">
                        {{ item.totalKQHocki2 }}
                    </td>
                    <td class="text-right">
                        {{ item.totalKQCanam }}
                    </td>
                    <td class="text-right">
                        {{ item.totalHsTotNghep }}
                    </td>
                </tr>
            </template>
            <template v-slot:pagi>
                <CustomPagination v-show="total_rows > 0" :tongbanghi="total_rows" :pageSize="pageSize"
                    :pageStart="pageStart" @pageChange="pageChange($event)" @pageSizeChange="pageSizeChange($event)">
                </CustomPagination>
            </template>
        </CustomTable>
    </div>
</template>

<script>
import ToolBar from '@/components/ToolBar.vue'
import CustomButton from '@/components/CustomButton.vue'
import { getFromSessionStorage } from '@/utils/session'

import sendRequest from '@/services'
import Api from '@/constants/Api'
import CustomTable from '@/components/CustomTable.vue'
import CustomPagination from '@/components/CustomPagination.vue'

export default {
    name: 'DataTransferSchedule',
    components: {
        ToolBar,
        CustomButton,

        CustomTable,
        CustomPagination
    },
    data() {
        return {
            start: 0,
            total_rows: 0,
            currentPage: 1,
            limit: 25,
            pageSize: 25,
            pageStart: false,

            unit_education: [],

            tableData: [],

            allData: [],
        }
    },

    methods: {
        pageSizeChange(e) {
        this.pageSize = e.soluong
        this.limit = e.soluong
        this.currentPage = 1
        this.start = 0
        
        this.renderTableFromCache() 
    },

    pageChange(e) {
        this.start = e.start
        this.limit = e.limit
        this.currentPage = e.currentPage
        
        this.renderTableFromCache()
    },

        checkTruocKhiTim() {
            this.pageStart = !this.pageStart
        },

        renderTableFromCache() {
            if (!this.allData || this.allData.length === 0) {
        this.tableData = []
        return
    }

        // Tính vị trí bắt đầu và kết thúc dựa trên trang hiện tại
        const start = (this.currentPage - 1) * this.limit
        const end = start + this.limit
        
        // Cắt dữ liệu từ cache đưa vào bảng hiển thị
        // Dùng slice để an toàn, tránh lỗi nếu end vượt quá độ dài mảng
        this.tableData = this.allData.slice(start, end)
    },

    async handleSearch() {
    try {
        // Lưu ý: Khi tìm kiếm mới, ta luôn reset về trang 1
        this.currentPage = 1
        this.start = 0

        const request_data = {
            start: 0, // Luôn gửi 0 vì API trả về tất cả
            limit: 9999, // Có thể để số lớn hoặc giữ nguyên logic cũ đều được do server trả full
            capHocList: this.selectedGradeLevelFromStore,
            maDonViList: this.unit_education,
            namHoc: this.selectedYearFromStore,
            maSo: this.auth_user.ma_so
        }

        const response = await sendRequest(
            Api.tiep_nhan_du_lieu_QLNT.bao_cao_tinh_hinh_nop_du_lieu.cap_so,
            request_data,
            this.request_headers,
            null
        )

        this.allData = response.tableData || []

        this.total_rows = this.allData.length
        
        this.renderTableFromCache()

    } catch (error) {
        console.log(error)
        this.tableData = []
        this.allData = []
        this.total_rows = 0
    }
}
    },
    mounted() { },

    computed: {
        list_unit_education() {
            return getFromSessionStorage('list_unit_education')
        },

        selectedYearFromStore() {
            return this.$store.state.selectedYear.selectedYear
        },
        selectedGradeLevelFromStore() {
            return this.$store.state.gradeLevel.gradeLevel
        },
        auth_user() {
            return getFromSessionStorage('auth_user')
        },
        request_headers() {
            return {
                token: this.auth_user.token
            }
        }
    }
}
</script>

<style scoped></style>
